import requestV2 from '@/service/request-v2'
import { normalizePageResult } from '@/service/adapters/page-result'
import type { PageQuery, PageResult } from '@/types/crud'

export interface PreSalesBuyingHistoryFilters {
  productName: string
  customerName: string
  nickname: string
  unionid: string
  empName: string
  deptName: string
  channelName: string
  isSigned: string
  tradeNo: string
  channelCode: string
  status: string
  isRefund: string
  payTime?: string[]
}

export interface PreSalesBuyingHistoryRecord {
  id?: string | number
  customerName: string
  nickname: string
  unionid: string
  channelName: string
  productName: string
  price: number
  signUrl: string
  isSigned: string
  deptName: string
  empName: string
  payTime: string
  tradeNo: string
  orderId: string
  status: string | number
  channelCode: string
  isRefund: string
  refundAmount: number
}

function buildParams(query: PageQuery<PreSalesBuyingHistoryFilters>) {
  return {
    ...query.filters,
    pageNo: query.pageNo,
    pageSize: query.pageSize
  }
}

async function requireExportFile(blob: Blob) {
  if (!blob.type.includes('application/json')) return blob
  const payload = JSON.parse(await blob.text()) as { message?: string }
  throw new Error(payload.message || '下载失败')
}

export async function fetchPreSalesBuyingHistoryPage(
  query: PageQuery<PreSalesBuyingHistoryFilters>,
  signal: AbortSignal
): Promise<PageResult<PreSalesBuyingHistoryRecord>> {
  const payload = await requestV2.get<unknown>({
    url: '/main/liveQuanzi/queryByCondition',
    params: buildParams(query),
    signal
  })
  return normalizePageResult<PreSalesBuyingHistoryRecord>(payload)
}

export function exportPreSalesBuyingHistory(
  query: PageQuery<PreSalesBuyingHistoryFilters>
) {
  return requestV2
    .get<Blob>({
      url: '/main/liveQuanzi/download',
      params: buildParams(query),
      responseType: 'blob'
    })
    .then(requireExportFile)
}
